<template>
  <div class="mt-2 border rounded">
    <div
      @click="toggleDetails"
      class="flex items-center group hover:bg-white transition-colors cursor-pointer"
    >
      <div class="sensitive flex-1 min-w-0 px-3 py-3 text-sm font-medium text-gray-900 cursor-pointer">
        {{ tagRelationship.entity_name }}
      </div>
      <div class="shrink-0 px-3">
        <svg
          class="w-3 h-3 text-gray-400 transition-transform duration-200"
          :class="showDetails ? 'transform rotate-180' : ''"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <div class="p-3 pt-0" v-if="showDetails">
      <div class="mb-1 text-sm">
        <div><span class="font-medium text-gray-500">Date Added:</span> {{ dateAdded }}</div>
        <div><span class="font-medium text-gray-500">Added By:</span> {{ addedBy }}</div>
      </div>
      <div v-if="hasMetaData(tagRelationship.metaData)" class="mt-2 pt-2 border-t border-gray-200">
        <DataTreeViewer :jsonData="tagRelationship.metaData" />
      </div>
    </div>
  </div>
</template>

<script>
import Multi_Button from '@/components/widgetcomponents/Multi_Button.vue'
import DataTreeViewer from '@/components/widgetcomponents/DataTreeViewer.vue'

export default {
  components: {
    Multi_Button,
    DataTreeViewer,
  },
  props: {
    tagRelationship: {
      type: Object,
    },
    expandDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDetails: false,
    }
  },
  computed: {
    dateAdded() {
      if (!this.tagRelationship.created_at) return 'N/A';
      return new Date(this.tagRelationship.created_at).toLocaleDateString();
    },
    addedBy() {
      switch (this.tagRelationship.originating_object_content_type_model) {
        case 'system':
          return 'System';
        case 'appuser':
          return this.tagRelationship.appuser_name || 'User';
        default:
          return 'Unknown';
      }
    }
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    hasMetaData(metaData) {
      return metaData && typeof metaData === 'object' && Object.keys(metaData).length > 0
    }
  },
  mounted() {
    this.showDetails = this.expandDetails;
  },
  watch: {
    expandDetails(newVal) {
      this.showDetails = newVal;
    }
  }
}
</script>

<style scoped>
</style>
